import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PercentageCircleComponent } from './percentage-circle.component';



@NgModule({
  declarations: [
    PercentageCircleComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PercentageCircleComponent
  ]
})
export class PercentageCircleModule { }
